import React, { FunctionComponent, useState } from 'react';
import '@justgiving/alert/src/Alert.scss';
import { useNotNullableContext } from '../../hooks/useNotNullableContext';
import { PageMetaContext } from '../../context/PageMetaContext';
import { useTranslation } from 'react-i18next';
import Alert from '@justgiving/alert';

export const Banner: FunctionComponent = () => {
  const { showBanner, bannerCopy } = useNotNullableContext(PageMetaContext);
  const { t } = useTranslation('common', { useSuspense: false });
  const [isClosed, setIsClosed] = useState(false);

  if (!showBanner || isClosed) {
    return null;
  }

  function handleClose() {
    setIsClosed(true);
  }

  return (
    <Alert type="info" onClose={handleClose}>
      {bannerCopy ?? t('banner.copy')}
    </Alert>
  );
};
